import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterMerchandiseTypesList } from "./list/list";
import { setMerchandiseTypes } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterMerchandiseTypesList } from "../../../../../redux/reducers/resources/master/merchandiseTypes/list";

export class MasterMerchandiseTypesContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterMerchandiseTypesList());
        store.dispatch(setMerchandiseTypes([]));
    }

    render(): React.ReactNode {
        return (
            <MasterMerchandiseTypesList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
